module.exports = __webpack_public_path__ + "static/media/paridhi.437d3dc5.jpeg";